<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-12 09:55:58
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-08 10:02:58
 * @Description: 待办事项详情页
-->
<template>
  <div class="pending-items-list">
    <!-- 详情页头部 -->
    <detail-header
      title="待办事项"
      icon="icon-tongxunlu"
      :iconStyle="iconStyle"
      @back="handleReturnClick"
    ></detail-header>
    <div class="container-body" v-loading="data.isLoading">
      <el-form label-width="70px">
        <div class="form">
          <el-form-item style="width:30%" label="关键词：">
            <el-input
              v-model="form.keyword"
              placeholder="请输入关键词"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item style="width:15%" label="状态：">
            <el-select
              style="width:100%"
              v-model="form.status"
              placeholder="请选择状态"
              clearable
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="未读"></el-option>
              <el-option value="1" label="已读"></el-option>
            </el-select>
          </el-form-item>
          <div class="btns" style="width:55%;padding-left:20px">
            <button
              class="query-button"
              @click="handleQueryClick"
              type="button"
            >
              查询
            </button>
            <button
              class="delete-button"
              @click="handleDeleteClick"
              type="button"
            >
              删除
            </button>
            <div class="sign-button">
              <el-dropdown @command="handleSignCommand" class="sign-dropdown">
                <span class="el-dropdown-link">
                  标记为
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">已读</el-dropdown-item>
                  <el-dropdown-item command="0">未读</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <button
              class="add-button"
              @click="handleAddClick"
              type="button"
              v-if="deptPower"
            >
              新增
            </button>
          </div>
        </div>
      </el-form>

      <div class="table-card">
        <detail-table
          ref="multipleTable"
          :data="data.list"
          :columns="tableColumns"
          height="calc(100vh - 313px)"
          :showBorder="false"
          :stripe="false"
          :header-cell-style="headerCellStyle"
          selection
          @row-click="handleDetailClick"
          @selection-change="handleSelectionChange"
        >
          <template #articleType="{scope}">
            <span
              v-if="scope.row.isRead == '0'"
              style="font-weight: bold;white-space: nowrap;"
              >{{ scope.row.articleType }}</span
            >
            <span v-else style="color: #8e9093;white-space: nowrap;">{{
              scope.row.articleType
            }}</span>
          </template>
          <template #title="{scope}">
            <span
              v-if="scope.row.priorityTpCode == '008-001'"
              style="color: #f56c6c; font-weight: 500;"
              >[加急]</span
            >
            <span v-if="scope.row.isRead == '0'" style="font-weight: bold;">{{
              scope.row.title
            }}</span>
            <span v-else style="color: #8e9093">{{ scope.row.title }}</span>
          </template>
          <template #content="{scope}">
            <span
              v-if="scope.row.isRead == '0'"
              style="font-weight: bold;white-space: nowrap;"
            >
              <!--              <span-->
              <!--                v-if="scope.row.content.toString().indexOf('&lt;span') == -1"-->
              <!--                >{{ scope.row.content }}</span-->
              <!--              >-->
              <span>{{ scope.row.content | filterContext }}</span>
            </span>
            <span v-else style="color: #8e9093;white-space: nowrap;">
              <!--              <span-->
              <!--                v-if="scope.row.content.toString().indexOf('&lt;span') == -1"-->
              <!--                >{{ scope.row.content }}</span-->
              <!--              >-->
              <span>{{ scope.row.content | filterContext }}</span>
            </span>
          </template>
          <template #initiatorName="{scope}">
            <span
              v-if="scope.row.initiatorName"
              style="padding-bottom: 2px;border-bottom: 1px solid #059bf6; color:#409eff; cursor: pointer"
              @click.stop="viewInitiatorName(scope.row)"
            >
              {{ scope.row.initiatorName }}
            </span>
          </template>
          <template #createTm="{scope}">
            <span v-if="scope.row.isRead == '0'" style="font-weight: bold;">{{
              scope.row.createTm | dateFormat
            }}</span>
            <span v-else style="color: #8e9093">{{
              scope.row.createTm | dateFormat
            }}</span>
          </template>

          <template #default="{scope}">
            <button
              type="button"
              class="eims-button"
              @click.stop="pendingPrev(scope.row)"
              v-if="scope.row.userId === scope.row.initiator"
            >
              查看
            </button>
          </template>
        </detail-table>
      </div>

      <div class="page">
        <el-pagination
          layout="sizes, prev, pager, next"
          :page-size="data.pageSize"
          :total="data.total"
          :page-sizes="data.pageSizeArray"
          :current-page="data.currentPage"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <common-dialog
      width="40%"
      :visible.sync="dialog.isShow"
      v-loading="dialog.isLoading"
      class="spec-dialog"
      @close="handleCloseDialog"
    >
      <div class="dialog-title" slot="title">
        <template>
          <div>{{ dialog.form.title }}</div>
        </template>
      </div>
      <div class="dialog-body" style="font-size: 16px;line-height: 30px">
        <div class="pending-time">
          {{ dialog.form.createTm | dateFormat }}
        </div>
        <p class="pending-content" v-html="dialog.form.content"></p>
      </div>
      <div class="dialog-footer" slot="footer">
        <common-button
          v-if="showConfirm"
          type="primary"
          style="margin-left:10px"
          @click="hanleConfirmFinish"
        >
          确认
        </common-button>
        <common-button type="cancel" @click="dialog.isShow = false">
          取消
        </common-button>
      </div>
    </common-dialog>

    <el-dialog
      :visible.sync="edited.editedDialogFlag"
      @close="handleCloseeditedDialog"
      min-width="430px"
      width="430px"
    >
      <div class="dialog-title" slot="title">
        新用户信息详情
      </div>
      <el-form label-width="110px" size="small">
        <el-form-item label="用户名:">
          <span class="dialog-content-span">{{ edited.name }}</span>
        </el-form-item>
        <el-form-item label="注册机构:">
          <span class="dialog-content-span">{{ edited.majorDepartName }}</span>
        </el-form-item>
        <el-form-item label="关联机构:" size="small" style="font-weight: 500;">
          <el-cascader
            ref="editDeptCascader"
            :props="{ checkStrictly: true }"
            :options="departments"
            @change="handleApproveDeptChange"
            :show-all-levels="false"
            clearable
            filterable
            style=""
          >
          </el-cascader>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <common-button
          @click="handleCommitDialog('1')"
          size="small"
          type="primary"
          style="text-align: center"
          >同意</common-button
        >
        <common-button
          @click="handleCommitDialog('0')"
          size="small"
          type="cancel"
          style="text-align: center"
          >拒绝</common-button
        >
      </template>
    </el-dialog>

    <el-dialog
      :visible.sync="reject.isShow"
      @close="handleCloseeditedDialog"
      width="300px"
    >
      <div class="dialog-title" slot="title">
        请输入拒绝原因
      </div>
      <div>
        <el-input v-model="reject.rejectReason"></el-input>
      </div>
      <template slot="footer">
        <common-button
          @click="handleCommitDialog('1')"
          size="small"
          type="primary"
          style="text-align: center"
          >确定</common-button
        >
      </template>
    </el-dialog>

    <PostCreate
      @sensitiveWord="sensitiveWord"
      ref="forum-create"
      :base-url="baseUrl"
      title="发布待办事项"
      :visible.sync="pendingCreateVisible"
      :has-attachment="false"
      :has-members="true"
      :has-draft-btn="false"
      priority-tp-code="008-003"
      :tips="pendingTips"
      content-type="待办事项"
      @refresh="handleQueryClick"
    >
    </PostCreate>

    <el-dialog
      class="view-dialog"
      :visible.sync="initiator.isShow"
      @close="handleCloseDialog"
    >
      <div style="height: 600px;overflow-y: auto">
        <MyInfo
          :userId="initiator.userId"
          :showDirected="false"
          :showEmptyInfo="false"
          v-if="initiator.isShow"
        ></MyInfo>
      </div>
    </el-dialog>

    <common-dialog
      width="70%"
      :visible.sync="recipients.isShow"
      v-loading="dialog.isLoading"
      class="spec-dialog-recipients"
      @close="handleCloseRecipients"
    >
      <div class="dialog-title" slot="title">
        <template>
          <div>接收人信息列表</div>
        </template>
      </div>
      <div class="dialog-body">
        <el-table
          v-loading="recipients.isLoading"
          height="calc(100vh - 500px)"
          :data="recipients.list"
          :header-cell-style="headerCellStyle"
        >
          <el-table-column
            prop="username"
            label="姓名"
            sortable
          ></el-table-column>
          <el-table-column
            prop="departmentName"
            label="单位"
            sortable
          ></el-table-column>
          <el-table-column
            prop="directionLv1TpDesc"
            label="一级研究方向"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="directionLv2TpDesc"
            label="二级研究方向"
            sortable
          ></el-table-column>
          <el-table-column
            prop="directionLv2Desc"
            label="其它研究方向"
            sortable
          ></el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            layout="sizes, prev, pager, next"
            :page-size="recipients.pageSize"
            :total="recipients.total"
            :page-sizes="recipients.pageSizeArray"
            :current-page="recipients.currentPage"
            @current-change="recipientsPageChange"
            @size-change="recipientsSizeChange"
          >
          </el-pagination>
        </div>
      </div>

      <div class="dialog-footer" slot="footer">
        <common-button type="cancel" @click="handleCloseRecipients">
          取消
        </common-button>
      </div>
    </common-dialog>

    <animation
      :loadingDataVisible="loadingDataVisible"
      :loadingText="loadingText"
    ></animation>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { mapState } from "vuex";
import { Message } from "element-ui";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";
import { articleMixin } from "../mixins/articleMixin";
import Animation from "../../components/loading/animation";
import DetailHeader from "@/components/common/DetailHeader";
import DetailTable from "@/components/common/DetailTable";
import PostCreate from "../../components/detail/PostCreate";
import MyInfo from "@/pages/user/MyInfo";

export default {
  name: "PendingItemsList",
  components: { PostCreate, Animation, DetailHeader, DetailTable, MyInfo },
  mixins: [articleMixin],
  data() {
    return {
      //true是结束,false是正在处理
      loadingDataVisible: false,
      pendingCreateVisible: false,
      loadingText: "",
      form: {
        keyword: "",
        status: ""
      },
      query: {
        keyword: "",
        status: ""
      },
      data: {
        isLoading: false,
        list: [],
        pageNum: 1,
        total: 0,
        currentPage: 1,
        pageSize: 20,
        pageSizeArray: PAGE_SIZE_ARRAY
      },
      recipients: {
        isShow: false,
        isLoading: false,
        list: [],
        form: [],
        pageNum: 1,
        total: 0,
        currentPage: 1,
        pageSize: 20,
        pageSizeArray: PAGE_SIZE_ARRAY
      },
      dialog: {
        isShow: false,
        isLoading: false,
        form: []
      },
      priorityCode: {
        all: "0",
        urgent: "008-001",
        secondary: "008-002",
        ordinary: "008-003"
      },
      iconStyle: {
        color: "#34c5e7",
        "font-size": "30px"
      },
      currPriority: "", //当前页面选择的事项优先级
      multipleSelection: [], //多选框选中的列表数据
      multipleSelectionIds: [], //多选框选中的id
      saveSelection: [], //保存的选中列表数据
      priorityText: "", //每条数据前面显示的优先级文字
      edited: {
        editedDialogFlag: false,
        name: "",
        majorDepartName: "",
        provinceName: "",
        cityName: "",
        departmentId: null,
        isApprv: "",
        rejectReason: "",
        userId: ""
      },
      addDepartment: {
        addDialogFlag: false
      },
      departments: [],
      reject: {
        isShow: false,
        rejectReason: ""
      },
      selectedDepartTp: null,
      tableColumns: [
        {
          label: "所属模块",
          prop: "articleType",
          align: "left",
          width: "150",
          showSlot: true,
          sortable: true
        },
        {
          label: "标题",
          prop: "title",
          align: "left",
          width: "400",
          showSlot: true,
          sortable: true
        },
        {
          label: "描述",
          prop: "content",
          align: "left",
          showSlot: true,
          sortable: true
        },
        {
          label: "发起人",
          prop: "initiatorName",
          align: "left",
          width: "100",
          showSlot: true,
          sortable: true
        },
        {
          label: "时间",
          prop: "createTm",
          align: "left",
          width: "100",
          showSlot: true,
          sortable: true
        },
        {
          label: "接收人",
          prop: "default",
          align: "center",
          width: "150",
          showSlot: true
        }
      ],
      baseUrl: "/eims-api/toDoList/publishTodo",
      showPublish: false,
      initiator: {
        userId: "",
        isShow: false
      }
    };
  },
  mounted() {
    this.queryData();
    this.$store.dispatch("getPriorityTotal");
    window.showApproveDialog = this.showApproveDialog;
    this.getDepartments();
  },

  methods: {
    showApproveDialog() {
      this.edited.editedDialogFlag = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/user/approve/list", {
          token: cookie.getCookie("token"),
          data: {
            userId: this.dialog.form.eventReferenceId
          }
        })
        .then(response => {
          let eimsUser = response.data.data.eimsUserList[0];
          this.edited.userId = eimsUser.userId;
          this.edited.name = eimsUser.name;
          this.edited.majorDepartName = eimsUser.majorDepartName;
          this.edited.majorDepartName = eimsUser.majorDepartName;
          this.edited.provinceName = this.getProvinceNameMethod(
            eimsUser.provinceCode
          );
          this.edited.cityName = this.getCityNameMethod(eimsUser.cityCode);
        })
        .finally(() => {});
    },

    getProvinceNameMethod(value) {
      for (let arr in this.eimsCodes) {
        if (this.eimsCodes[arr].cd == value) {
          return this.eimsCodes[arr].cdDesc;
        }
      }
      return "";
    },
    getCityNameMethod(value) {
      for (let arr in this.eimsCodes) {
        if (this.eimsCodes[arr].cd == value) {
          return this.eimsCodes[arr].cdDesc;
        }
      }
      return "";
    },

    handleApproveDeptChange(value) {
      if (this.$refs.editDeptCascader.getCheckedNodes()[0] !== undefined) {
        this.selectedDepartTp = this.$refs.editDeptCascader.getCheckedNodes()[0].data.tp;
      } else {
        this.selectedDepartTp = null;
      }
      this.$refs.editDeptCascader.dropDownVisible = false;
      this.edited.departmentId = value[value.length - 1];
    },
    handleCloseRecipients() {
      this.recipients = this.$options.data().recipients;
    },

    handleCloseeditedDialog() {
      this.edited.editedDialogFlag = false;
      this.edited.name = "";
      this.edited.majorDepartName = "";
      this.edited.departmentId = null;
      this.edited.userId = "";
      this.edited.isApprv = "";
      this.edited.rejectReason = "";
      this.edited.provinceName = "";
      this.edited.cityName = "";
      this.selectedDepartTp = null;
      this.$refs.editDeptCascader.handleClear();
    },

    handleRejectDialog() {
      this.reject.isShow = true;
    },

    handleCommitDialog(isApprv) {
      let _this = this;
      if (isApprv == "1" && !_this.edited.departmentId) {
        Message.error({ message: "关联机构不能为空！", showClose: true });
        return;
      }
      if (isApprv == "1" && _this.selectedDepartTp < 5) {
        Message.error({
          message: "关联机构只能选择医院和科室！",
          showClose: true
        });
        return;
      }
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/user/approve", {
          token: token,
          data: {
            userId: _this.edited.userId,
            isApprv: isApprv,
            departmentId: _this.edited.departmentId,
            rejectReason: ""
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            Message.success({ message: "审核成功", showClose: true });
            _this.handleCloseeditedDialog();
            _this.queryData();
            this.dialog.isShow = false;
          }
        });
    },

    getDepartments() {
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/department/findCurrentAndSub",
          {
            token: token,
            data: {
              pageSize: -1
            }
          }
        )
        .then(response => {
          this.departments = response.data.data.departments;
        });
    },

    //返回上个页面
    handleReturnClick() {
      this.$router.go(-1);
    },

    //查询列表
    queryData(flag) {
      let _this = this;
      _this.loadingDataVisible = true;
      // 以下代码是分级时使用
      // if (flag){
      //   _this.currPriority = flag;
      // }else {
      //   _this.currPriority = this.preservePriority;
      // }
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/toDoList/list", {
          token: token,
          data: {
            keyword: _this.query.keyword,
            status: _this.query.status,
            pageNum: _this.data.pageNum,
            pageSize: _this.data.pageSize,
            priority: "0"
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            _this.data.list = response.data.data.eimsTodoList;
            this.data.total = response.data.data.total;
          }
        })
        .finally(() => {
          _this.loadingDataVisible = false;
        });
    },

    //查询
    handleQueryClick() {
      this.query.keyword = this.form.keyword;
      this.query.status = this.form.status;
      this.handlePageChange(1);
    },

    //分页
    handlePageChange(val, flag) {
      this.data.currentPage = val;
      this.data.pageNum = val;
      this.queryData();
      //切换页码后，滚动条回到顶部
      this.$nextTick(() => {
        this.$refs.multipleTable.$refs.table.bodyWrapper.scrollTop = 0;
      });
      //以下代码是分级时使用
      // if (flag){
      //   this.queryData(flag);   //有传flag的时候就根据标签传参数
      // } else {
      //   this.queryData(this.currPriority);    //没有flag的时候，就在当前的待办事项上分页查询
      // }
    },

    handleSizeChange(val) {
      this.data.pageSize = val;
      this.queryData();
      this.$nextTick(() => {
        this.$refs.multipleTable.$refs.table.bodyWrapper.scrollTop = 0;
      });
    },
    recipientsPageChange(val) {
      this.recipients.currentPage = val;
      this.recipients.pageNum = val;
      this.pendingPrev(this.recipients.form);
    },
    recipientsSizeChange(val) {
      this.recipients.pageSize = val;
      this.pendingPrev(this.recipients.form);
    },
    pendingPrev(row) {
      this.recipients.isLoading = true;
      this.recipients.form = row;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/toDoList/findTodoMember", {
          token: token,
          data: {
            todoId: row.id,
            pageNum: this.recipients.pageNum,
            pageSize: this.recipients.pageSize
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            console.log(response.data.data);
            this.recipients.isShow = true;
            this.recipients.list = response.data.data.todoMembers;
            this.recipients.total = response.data.data.total;
          }
        })
        .finally(() => {
          this.recipients.isLoading = false;
        });
    },

    //修改状态为已读
    changeToRead(row) {
      let _this = this;
      _this.loadingDataVisible = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/toDoList/changeStatus", {
          token: token,
          data: {
            id: row.id
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            this.queryData();
            this.dialog.form = row;
          }
        })
        .finally(() => {
          _this.loadingDataVisible = false;
        });
    },

    //查看详情
    async handleDetailClick(row, index) {
      if (
        row.postTpCode != null &&
        (this.superPower || this.deptPower || this.systemPower)
      ) {
        this.queryArticle(row);
      } else {
        //查询用户的信息是否已审核通过
        if (row.articleType === "用户审核") {
          let flag = true;
          await this.checkUserIsApproveStatus(row).then(rep => {
            flag = rep;
          });

          if (!flag) {
            Message.warning("用户已审核通过或该待办事项不存在！");
          } else {
            this.dialog.isShow = true;
          }
        } else {
          this.dialog.isShow = true;
        }
        this.changeToRead(row);
      }
    },

    async checkUserIsApproveStatus(row) {
      let token = cookie.getCookie("token");
      this.loadingDataVisible = true;
      return new Promise(async (resolve, reject) => {
        await http
          .post(
            window.config.api.baseUrl + "/eims-api/user/findUserApproveStatus",
            {
              token: token,
              data: {
                userId: row.eventReferenceId
              }
            }
          )
          .then(response => {
            if (response.data.code == "00000") {
              resolve(response.data.data.eimsUser !== null);
            }
            reject(false);
          })
          .catch(err => {
            reject(err);
          })
          .finally(() => {
            this.loadingDataVisible = false;
          });
      });
    },

    //关闭弹窗
    handleCloseDialog() {
      this.dialog.isShow = false;
      this.dialog.form = {};
      this.saveSelection = this.multipleSelection;
      // this.handlePageChange(this.data.currentPage);
    },

    //选择列表数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let ids = [];
      this.multipleSelection.forEach(arr => {
        ids.push(arr.id);
      });
      this.multipleSelectionIds = ids;
    },

    //删除请求
    handleDeleteClick() {
      let _this = this;
      if (_this.multipleSelectionIds.length == 0) {
        Message.error({ message: "未选中任何待办事项！", showClose: true });
      } else {
        _this
          .$confirm("确定删除该待办事项？", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.loadingDataVisible = true;
            let token = cookie.getCookie("token");
            http
              .post(window.config.api.baseUrl + "/eims-api/toDoList/delete", {
                token: token,
                data: {
                  multipleSelectionIds: _this.multipleSelectionIds
                }
              })
              .then(response => {
                let status = response.data.code;
                if (status == "00000") {
                  Message.success({ message: "删除成功", showClose: true });
                  _this.$store.dispatch("getPriorityTotal");
                  _this.handlePageChange(
                    _this.data.currentPage,
                    _this.currPriority
                  );
                }
              })
              .finally(() => {
                _this.loadingDataVisible = false;
              });
          });
      }
    },

    //标记为请求
    handleSignCommand(command) {
      let _this = this;
      let text = command == 1 ? "已读" : "未读";
      if (_this.multipleSelectionIds.length == 0) {
        Message.error({ message: "未选中任何待办事项！", showClose: true });
      } else {
        _this
          .$confirm("确定将该事项标为" + text + "?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.loadingDataVisible = true;
            let token = cookie.getCookie("token");
            http
              .post(window.config.api.baseUrl + "/eims-api/toDoList/sign", {
                token: token,
                data: {
                  multipleSelectionIds: _this.multipleSelectionIds,
                  status: command
                }
              })
              .then(response => {
                let status = response.data.code;
                if (status == "00000") {
                  Message.success({ message: "标记成功", showClose: true });
                  _this.$store.dispatch("getPriorityTotal");
                  _this.handlePageChange(
                    _this.data.currentPage,
                    _this.currPriority
                  );
                }
              })
              .finally(() => {
                _this.loadingDataVisible = false;
              });
          })
          .catch(() => {});
      }
    },

    handleMoveCommand(command) {
      let _this = this;
      let text =
        command == "008-001" ? "紧急" : command == "008-002" ? "次级" : "普通";
      if (_this.multipleSelectionIds.length == 0) {
        Message.error({ message: "未选中任何待办事项！", showClose: true });
      } else {
        _this
          .$confirm("确定将该事项移动到" + text + "待办列表?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            _this.loadingDataVisible = true;
            let token = cookie.getCookie("token");
            http
              .post(window.config.api.baseUrl + "/eims-api/toDoList/move", {
                token: token,
                data: {
                  multipleSelectionIds: _this.multipleSelectionIds,
                  priorityTpCode: command
                }
              })
              .then(response => {
                let status = response.data.code;
                if (status == "00000") {
                  Message.success({ message: "移动成功", showClose: true });
                  _this.$store.dispatch("getPriorityTotal");
                  _this.handlePageChange(
                    _this.data.currentPage,
                    _this.currPriority
                  );
                }
              })
              .finally(() => {
                _this.loadingDataVisible = false;
              });
          });
      }
    },
    //查看文章状态是否发生变化
    queryArticle(row) {
      let _this = this;
      _this.loadingDataVisible = false;
      let token = cookie.getCookie("token");
      let content = row.content;
      _this.changeToRead(row);
      http
        .post(window.config.api.baseUrl + "/eims-api/share/approve/findById", {
          token: token,
          data: {
            postCode: content.substring(
              content.indexOf("code=") + 5,
              content.indexOf('"target="')
            ),
            tpCode: row.postTpCode
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            //判断文章不存在或者文章状态发生变化
            if (response.data.data.responseStr) {
              Message.warning(response.data.data.responseStr);
              return false;
            }
            //判断是否为拒绝
            // if(response.data.data.article.status == '2'){
            //   _this.changeToRead(row);
            //   return false;
            // }
            _this.dialog.isShow = true;
          } else {
            return false;
          }
        })
        .finally(() => {});
    },
    handleAddClick() {
      this.pendingCreateVisible = true;
    },
    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {
          items();
        })
        .catch(_ => {});
    },
    viewInitiatorName(row) {
      console.log(row);
      if (row.initiatorName) {
        let userId = row.initiator;
        this.initiator.userId = userId;
        this.initiator.isShow = true;
      }
    },
    hanleConfirmFinish() {
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/toDoList/finishToDoList", {
          token: token,
          data: {
            id: this.dialog.form.id
          }
        })
        .then(response => {
          if (response.data.code == "00000") {
            this.queryData();
          }
        })
        .finally(() => {
          this.dialog.isShow = false;
        });
    }
  },

  watch: {
    "data.list"() {
      //数据更新后，根据保存的选择列表，将数据回显选择table列表
      this.$nextTick(() => {
        if (this.saveSelection) {
          this.saveSelection.forEach(row => {
            let arr = this.data.list.find(item => {
              return item.id === row.id;
            });
            this.$refs.multipleTable.$refs.table.toggleRowSelection(arr);
          });
        }
      });

      //判断table中每条数据的优先级[]
      this.data.list.find(arr => {
        if (arr.priorityTpCode == "008-001") {
          this.priorityText = "[紧急]";
        } else if (arr.priorityTpCode == "008-002") {
          this.priorityText = "[次级]";
        } else if (arr.priorityTpCode == "008-003") {
          this.priorityText = "[普通]";
        }
      });
    }
  },

  computed: {
    showConfirm() {
      return (
        (!this.dialog.form.eventType || this.dialog.form.eventType === "4") &&
        this.dialog.form.isFinish === "0"
      );
    },
    ...mapState({
      urgentTotal: state => state.pendingItemListModule.urgentTotal,
      secondaryTotal: state => state.pendingItemListModule.secondaryTotal,
      ordinaryTotal: state => state.pendingItemListModule.ordinaryTotal,
      // allTotal: state => state.pendingItemListModule.totals,
      preservePriority: state => state.pendingItemListModule.priority,
      superPower: state => state.userPowerStore.superPower,
      systemPower: state => state.userPowerStore.systemPower,
      deptPower: state => state.userPowerStore.deptPower,
      eimsCodes: state => state.codeDictModule.eimsCodes
    })
  }
};
</script>

<style lang="scss" scoped>
.pending-items-list {
  margin: 20px;
  height: calc(100vh - 109px);
  background-color: #fff;
  box-shadow: 1px 2px 5px #ccc;
  .container-body {
    .form {
      display: flex;
      button {
        width: 70px;
        height: 40px;
        color: white;
        border-radius: 5px;
        font-size: 16px;
      }
      .btns {
        display: flex;
        .query-button {
          border: #3ec4db 1px solid;
          background: #3ec4db;
          &:hover {
            background-color: #56b9ca;
          }
          &:active {
            background-color: #89deed;
          }
        }
        .delete-button {
          border: #ea7277 1px solid;
          background: #ea7277;
          margin: 0 10px;
          &:hover {
            background-color: #c67073;
          }
          &:active {
            background-color: #ed9b9e;
          }
        }
        .add-button {
          border: #d7d3d3 1px solid;
          background: #d7d3d3;
          margin: 0 10px;
          &:hover {
            background-color: #c5bebe;
          }
          &:active {
            background-color: #f5f1f1;
          }
        }
        .sign-button {
          height: 40px;
          color: white;
          border-radius: 5px;
          font-size: 16px;
          border: #f78a74 1px solid;
          background: #f78a74;
          width: 100px;
          cursor: pointer;
          &:hover {
            background-color: #e48775;
          }
          &:active {
            background-color: #d8988c;
          }
          .el-dropdown-link {
            color: #fff;
            font-size: 16px;
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
        .sign-dropdown {
          width: 100%;
          text-align: center;
          line-height: 40px;
        }
      }
    }
    .table-card {
      margin-bottom: 20px;
      .eims-button {
        font-size: 16px;
        color: #409eff;
        border-color: transparent;
        background: transparent;
        white-space: nowrap;
        &:focus {
          outline: none;
        }
      }
    }
    .page {
      float: right;
      padding: 3px 0;
    }
  }
  .spec-dialog-recipients {
    .dialog-body {
    }
    .page {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
  }
  .spec-dialog {
    .dialog-body {
      overflow: auto;
      height: 300px;
      .pending-content {
        text-indent: 2em;
        clear: both;
      }
      .pending-time {
        font-size: 15px;
        float: right;
        color: #9e9e9f;
        margin-bottom: 10px;
      }
    }
  }
  .dialog-footer {
    button {
      float: right;
    }
  }
}

/deep/ .el-dialog__body {
  padding: 15px !important;
}
/deep/ .el-dialog__footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/pendingItems/PendingItemsList.vue